<template>
  <div>
    <SerialPack :url="url" cur-class="one_plus_six" />
  </div>
</template>

<script>
import SerialPack from '@/views/config/activity-auxiliary/serialPack.vue'
export default {
  name: 'OnePlusSix',
  components: {
    SerialPack
  },
  data() {
    return {
      url: '/config/activity-auxiliary/onePlusSix'
    }
  }
}
</script>

<style scoped>

</style>
